@let isMobile = breakpoints() === "mobile";
<header>
  <div class="container">
    <div class="row bottom-lg hero-content">
      <div class="col-lg-8 col-xs-12 content">
        @if (subtitle()) {
          <app-title [titles]="[subtitle()]" />
        }
        @if (title()) {
          <app-title [titles]="[title()]" class="title" />
        }
        @if (data().author || publication()) {
          <p class="meta">
            @if (data().author; as author) {
              <span class="meta-item">
                Article rédigé par
                @if (author.url) {
                  <a
                    [attr.aria-label]="author.name + ' (nouvel onglet)'"
                    [href]="author.url"
                    class="meta-author"
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ author.name }}</a
                  >
                } @else {
                  <span class="meta-author">{{ author.name }}</span>
                }
              </span>
            }
            @if (publication(); as publication) {
              <span class="meta-item">
                {{ publication.label }}
                <time [attr.datetime]="publication.date">{{ publication.date | date: "d MMMM y" }}</time>
              </span>
            }
          </p>
        }
        @if (data().text; as text) {
          <p class="paragraph">{{ text }}</p>
        }

        @if (socialNetworks() && isMobile) {
          <div class="social">
            <span class="social-title">Partager</span>
            @if (socialNetworks() && socialNetworks().length) {
              <app-social-networks [items]="socialNetworks()" [style]="socialNetworksStyle()" class="social-networks" />
            }
          </div>
        }
      </div>
      @if (!isMobile && data().isMenu) {
        <div class="col-lg-2 col-lg-offset-2">
          <ng-container *ngTemplateOutlet="menuDisplay" />
        </div>
      }
      @if (!isMobile && socialNetworks() && socialNetworks().length && !data().isMenu) {
        <div class="col-lg-2 col-lg-offset-2 content content-social">
          <div class="social">
            <span class="social-title">Partager</span>
            <app-social-networks [items]="socialNetworks()" [style]="socialNetworksStyle()" class="social-networks" />
          </div>
        </div>
      }
    </div>
  </div>
  @if (data().video && data().video!.mp4Url) {
    <app-video
      [isPlayFullscreen]="true"
      [isResetAfterFullscreen]="false"
      [isHidePosterGoingFullscreen]="true"
      [mp4Url]="data().video!.mp4Url!"
      [previewImage]="data().image"
      [posterStyle]="{ width: isMobile ? 640 : 1920, height: isMobile ? 279 : 837 }"
      [style]="{ width: '100%' }" />
  } @else {
    @if (data().image; as image) {
      <div class="img-wrapper">
        <app-image [image]="image" [size]="{ dh: 900, mh: 562 }" class="img" />
      </div>
    }
  }
  <ng-template #image>
    @if (data().image; as image) {
      <div class="img-wrapper">
        <app-image [image]="image" [size]="{ dh: 900, mh: 562 }" class="img" />
      </div>
    }
  </ng-template>
  @if (data().isMenu) {
    <div class="container">
      <div class="row">
        @if (isMobile) {
          <div class="col-xs-12">
            <ng-container *ngTemplateOutlet="menuDisplay" />
          </div>
        }
      </div>
    </div>
  }

  <ng-template #menuDisplay>
    @if (data().menu && data().menu!.length > 0) {
      <ul class="links">
        @for (m of data().menu; track m) {
          @if (m.anchor && m.label) {
            <li class="link">
              <hr class="link-separator" />
              <a (click)="goToSection(m.anchor)">
                {{ m.label }}
                <i [iconName]="'ARROW_DOWN'" color="ANCHOR" size="1.6rem"></i>
              </a>
            </li>
          }
        }
      </ul>
    } @else {
      @if (menu$ | async; as menu) {
        <ul class="links">
          @for (m of menu; track m) {
            @if (m.anchor && m.label) {
              <li class="link">
                <hr class="link-separator" />
                <a (click)="goToSection(m.anchor)">
                  {{ m.label }}
                  <i [iconName]="'ARROW_DOWN'" color="ANCHOR" size="1.6rem"></i>
                </a>
              </li>
            }
          }
        </ul>
      }
    }
  </ng-template>
</header>
